import { analytics as bloodhoundAnalytics } from "@sendgrid/bloodhound";
import { AnalyticsOptions } from "@sendgrid/bloodhound/dist/src/config";
import { getDatadogRumOptions } from "./datadogRumOptions";

export function init() {
  // We want to make analytics work with bloodhound.
  const options = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://api.sendgrid.com",
    segmentApiKey: process.env.REACT_APP_SEGMENT_API_KEY || "",
    datadogRum: getDatadogRumOptions(),
  } as AnalyticsOptions;

  bloodhoundAnalytics.init(options);
}
